import type { AccountPaymentEntitlement } from '../api';

export const ACCOUNT_PAYMENT_DATA_UPDATED_EVENT = 'fluxmind-account-payment-data-updated';
export const ACCOUNT_ENTITLEMENT_UPDATED_EVENT = 'fluxmind-account-entitlement-updated';

export interface AccountPaymentDataUpdatedDetail {
  active?: boolean;
  computeBalance?: number | null;
  entitlement?: AccountPaymentEntitlement | null;
  reason?: string;
}

export function dispatchAccountPaymentDataUpdated(detail: AccountPaymentDataUpdatedDetail = {}) {
  window.dispatchEvent(new CustomEvent(ACCOUNT_PAYMENT_DATA_UPDATED_EVENT, { detail }));
}

export function dispatchAccountEntitlementUpdated(detail: { active?: boolean } = {}) {
  window.dispatchEvent(new CustomEvent(ACCOUNT_ENTITLEMENT_UPDATED_EVENT, { detail }));
}
